


























/**
 * @file 处理带有评论表情包
 */
import { transformContentAST, PROCESSORS } from '@/components/comment/parser/index';
import { defineComponent, computed } from '@vue/composition-api';
import commentModel from '../../commentModel';
import { useApolloModel } from 'vue-apollo-model';

export default defineComponent({
    props: {
        content: {
            type: String,
            default: '',
        },
        processors: {
            type: Array,
            default: () => {
                return [PROCESSORS.EMOJI, PROCESSORS.AT];
            },
        },
        emojiStyle: {
            type: Object,
            default: () => ({}),
        },
        isDark: {
            type: Boolean,
        },
        isLogin: {
            type: Boolean,
        },
    },
    setup(props) {
        const model = useApolloModel(commentModel);
        const contentAst = computed(() => {
            const newProcessors = props.processors.map((processor: any) => {
                return processor === PROCESSORS.EMOJI ? processor(model.emojiIconUrls) : processor;
            });
            return transformContentAST(props.content, newProcessors);
        });

        return {
            contentAst,
        };
    },
});
